export const radii = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '32px',
};
